const APPLICATION_STORES_NAMESPACE = 'assistant-main-app';

export const createStoreId = (
  storeName: string,
  namespace: string = APPLICATION_STORES_NAMESPACE
): string => {
  return `${namespace}-${storeName}`;
};
